import $ from 'jquery';
import styles from './theme2.less';
import { iconfont } from '../../utils/utils';
import theme1 from './theme1';

class SceneList extends theme1 {
  constructor(props) {
    super(props);
  }

  _createWrapper() {
    return $(
      `<div class="${styles['scene-list-wrapper']} ${styles['scene-list-wrapper-theme2']}"></div>`,
    );
  }

  _getGroupItem(params) {
    const { item, focusFirst, pIndex, index, parent } = params;
    //生成分组item
    if (!item) return;
    const { name, id, thumb } = item;
    const isCurGroup = this.curGroups.indexOf(id) > -1 ? true : false; //是否是当前激活全景所在的分组

    let $item = $(`
    <div 
    class="${styles['group-wrapper']} ${styles['item-wrapper']} ${
      isCurGroup ? styles['active'] : ''
    } ${focusFirst && index == 0 ? styles['active'] : ''}" 
    data-group="${id}" data-parent="${
      parent ? parent.id : 0
    }"  data-name="${name}" title="${name}" data-index="${pIndex},${index}">
      <div class="${styles['group-item']} ${styles['list-item']}">
        <div class="${styles['group-name']} ${styles['item-name']}">${name}</div>
      </div>
    </div>`);
    return $item;
  }

  _getPanoItem(params) {
    const { item, pIndex, index, pid } = params;
    //生成全景item
    if (!item) return;
    const { name, id, thumb } = item;
    const isActivePano = this.activePano && this.activePano.id == id ? true : false;
    const isVisitedPano = this.visitedPanos.indexOf(Number(id)) > -1 ? true : false;

    let $item = $(`
      <div 
      class="${styles['pano-wrapper']} ${styles['item-wrapper']} ${
      isActivePano ? styles['active'] : ''
    } ${isVisitedPano ? styles['visited'] : ''}" 
      data-pano="${id}" data-parent="${pid}"  data-name="${name}" title="${name}">
      <div 
      class="${styles['pano-item']} ${styles['list-item']}" 
      style="background-image:url('${thumb}')">
        ${
          isVisitedPano
            ? `<span class="${styles['visited-icon']}">${iconfont('iconyidu')}</span>`
            : ''
        }
          <div class="${styles['pano-name']} ${styles['item-name']}">${name}</div>
        </div>
      </div>`);
    return $item;
  }
}

export default SceneList;
